let PriceOrigin = {
  BLUMAR: {id: 1, name: 'Blumar'},
  OMNIBEES: {id: 2, name: 'Omnibees'}
};

export default PriceOrigin;
export const priceOrigin = Object.keys(PriceOrigin).map(key => PriceOrigin[key]);



// WEBPACK FOOTER //
// ./src/enums/PriceOrigin.js